import styled from 'styled-components';
import { baseVariables, toRem } from '../../styles';
export const StyledHeaderLogo = styled.div`
  position: relative;
  height: ${toRem(52)};
  width: ${toRem(126)};
  left: ${toRem(8)};
  overflow: hidden;

  a {
    &:focus-visible {
      outline: none;
    }
  }

  &:has(a:focus-visible) {
    outline: auto ${toRem(1)};
    outline-offset: ${toRem(1)};
  }

  @media ${baseVariables.mediaQuery.sm} {
    height: ${toRem(72)};
    width: ${toRem(178)};
    left: ${toRem(10)};
    top: ${toRem(16)};
  }

  @media ${baseVariables.mediaQuery.lg} {
    width: ${toRem(157)};
    left: ${toRem(-48)};
  }

  .t-program-logo-alt-color {
    padding-left: ${toRem(36)};
    padding-top: ${toRem(22)};
    font-size: 2.7rem;
    display: block;
    font-weight: 400;
    &::before {
      bottom: ${toRem(3)};
      right: ${toRem(2)};
    }

    @media ${baseVariables.mediaQuery.sm} {
      font-size: 3.8rem;
      padding-left: ${toRem(45)};
      padding-top: ${toRem(30)};

      &::before {
        right: ${toRem(9)};
      }
    }

    @media ${baseVariables.mediaQuery.lg} {
      padding-left: 2rem;

      &::before {
        right: ${toRem(1)};
      }
    }

    &.m-header__logo-icon:hover {
      color: inherit;
    }
  }
`;
